import { api, writeDB } from './store';
import { Address } from './company';
import { getOrder, loadOrderWithItemGroups } from './order';
import { Document } from './document';
import { apollo } from './graphql';
import { REMOVE_DELIVERY_FROM_PICKLIST } from './queries/delivery';

/* INTERACES */
export type DeliveryStatus = 'draft' | 'pending' | 'fulfillment' | 'sent' | 'canceled';
export type DeliveryNoteType = 'inventory_correction' | 'damage' | 'new_goods' | 'circulating_goods' | 'other';
export const deliveryNoteTypes: DeliveryNoteType[] = [
  'inventory_correction',
  'damage',
  'new_goods',
  'circulating_goods',
  'other',
];

export interface Delivery extends Document {
  outgoing: boolean;
  status: DeliveryStatus;
  deliveryNoteType: DeliveryNoteType;
  trackingCode?: string;
  trackingUrl?: string;
  picklistId?: string;
  sentAt?: string;
  shippingMethodId?: string;
  skipEmailDelivery?: boolean;
  dhlLabelsUrl?: string;
  requiresInvoiceDownload?: boolean;
}

/* DELIVERIES CREATE */
export async function createDelivery(orderId: string, address?: Address): Promise<Delivery> {
  const response = await api.createDelivery({ orderId, address });
  return response.data as Delivery;
}

/* DELIVERIES READ */
export async function getDelivery({ deliveryId }: { deliveryId: string }): Promise<Delivery> {
  const response = await api.showDelivery({ deliveryId });
  writeDB.table('deliveries').upsert(response.data);
  return response.data as Delivery;
}

export async function getDeliveryWithOrder(deliveryId: string): Promise<void> {
  const response = await api.showDelivery({ deliveryId });
  const delivery = response.data as Delivery;
  const orderId = delivery.orderId;
  if (orderId) {
    await loadOrderWithItemGroups(orderId);
  }

  if (orderId) {
    writeDB.table('deliveries').upsert({
      ...delivery,
      order: writeDB.table('orders').find(orderId),
    });
  }
}
/* DELIVERIES UPDATE */
export async function updateDelivery(deliveryId: string, delivery: Partial<Delivery>): Promise<void> {
  await api.updateDelivery({
    deliveryId,
    ...delivery,
  });
  if (delivery.orderId) {
    await getOrder(delivery.orderId);
  }
}

/* DELIVERIES DELETE */
export async function deleteDelivery(orderId: string, deliveryId: string): Promise<void> {
  const order = writeDB.table('orders').find(orderId);
  if (order) {
    await api.destroyDelivery({ deliveryId });
    await getOrder(order.id);
  }
}

/* HELPERS */
export function getDeliveryStatus(status: DeliveryStatus): DeliveryStatus | 'booked' {
  if (status === 'sent') {
    return 'booked';
  }
  return status;
}

/* REMOVE A DELIVERY FROM ITS PICKLIST */
export async function removeDeliveryFromPicklist(deliveryId: string): Promise<void> {
  await apollo.mutate({
    mutation: REMOVE_DELIVERY_FROM_PICKLIST,
    variables: { deliveryId },
  });
}
